"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tabs = exports.Tab = void 0;
var react_1 = __importStar(require("react"));
var theme_1 = require("../../../mantine-theme/src");
var ElementsGroup_1 = require("../ElementsGroup/ElementsGroup");
var Tab_1 = require("./Tab/Tab");
Object.defineProperty(exports, "Tab", { enumerable: true, get: function () { return Tab_1.Tab; } });
var TabControl_1 = require("./TabControl/TabControl");
var Tabs_styles_1 = __importDefault(require("./Tabs.styles"));
function clamp(value, min, max) {
    return Math.min(Math.max(value, min), max);
}
function getPreviousTab(active, tabs) {
    for (var i = active - 1; i >= 0; i -= 1) {
        if (!tabs[i].props.disabled) {
            return i;
        }
    }
    return active;
}
function getNextTab(active, tabs) {
    for (var i = active + 1; i < tabs.length; i += 1) {
        if (!tabs[i].props.disabled) {
            return i;
        }
    }
    return active;
}
function findInitialTab(tabs) {
    for (var i = 0; i < tabs.length; i += 1) {
        if (!tabs[i].props.disabled) {
            return i;
        }
    }
    return -1;
}
function Tabs(_a) {
    var children = _a.children, initialTab = _a.initialTab, themeOverride = _a.themeOverride, active = _a.active, _b = _a.position, position = _b === void 0 ? 'left' : _b, _c = _a.grow, grow = _c === void 0 ? false : _c, onTabChange = _a.onTabChange, color = _a.color, others = __rest(_a, ["children", "initialTab", "themeOverride", "active", "position", "grow", "onTabChange", "color"]);
    var classes = Tabs_styles_1.default({ theme: theme_1.useMantineTheme(themeOverride) });
    var controlRefs = react_1.useRef({});
    var tabs = react_1.default.Children.toArray(children).filter(function (item) { return item.type === Tab_1.Tab; });
    var _d = react_1.useState(typeof initialTab === 'number' ? initialTab : findInitialTab(tabs)), _activeTab = _d[0], _setActiveTab = _d[1];
    var activeTab = clamp(typeof active === 'number' ? active : _activeTab, 0, tabs.length - 1);
    var setActiveTab = function (tabIndex) {
        _setActiveTab(tabIndex);
        if (typeof onTabChange === 'function') {
            onTabChange(tabIndex);
        }
    };
    var handleKeyDown = function (event) {
        if (event.nativeEvent.code === 'ArrowRight') {
            var nextTab = getNextTab(activeTab, tabs);
            setActiveTab(nextTab);
            controlRefs.current[nextTab].focus();
        }
        if (event.nativeEvent.code === 'ArrowLeft') {
            var previousTab = getPreviousTab(activeTab, tabs);
            setActiveTab(previousTab);
            controlRefs.current[previousTab].focus();
        }
    };
    var panes = tabs.map(function (tab, index) { return (react_1.default.createElement(TabControl_1.TabControl, { key: index, active: activeTab === index, tabProps: tab.props, onKeyDown: handleKeyDown, color: color, elementRef: function (node) {
            controlRefs.current[index] = node;
        }, onClick: function () { return activeTab !== index && setActiveTab(index); } })); });
    var content = tabs[activeTab].props.children;
    return (react_1.default.createElement("div", __assign({}, others),
        react_1.default.createElement("div", { className: classes.tabs },
            react_1.default.createElement(ElementsGroup_1.ElementsGroup, { className: classes.tabsInner, role: "tablist", "aria-orientation": "horizontal", spacing: 0, position: position, grow: grow }, panes)),
        content && (react_1.default.createElement("div", { "data-mantine-tab-content": true, className: classes.body, role: "tabpanel" }, content))));
}
exports.Tabs = Tabs;
Tabs.displayName = '@mantine/core/Tabs';
